import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'
import { Navigation } from './Navigation'

export class EventSlider {
  constructor() {
    const keenSlide = document.querySelectorAll('.js-keen_slide')
    const len = keenSlide.length
    const progress = document.querySelector('.js-slide_progress')
    const target = document.querySelector('#js-event_slider')
    if (!target) return

    const init = () => {
      const wrap = document.querySelector('.c-common_slider')
      if (!wrap) return
      const wrapWidth = wrap.clientWidth
      for (let i = 0; i < len; i++) {
        const newList = document.createElement('li')
        newList.classList.add('js-progress_list')
        if (i === 0) {
          newList.classList.add('is-act')
        }
        newList.style.width = (wrapWidth * 0.8) / len + 'px'
        progress.appendChild(newList)
      }
    }

    const clickEvent = (target) => {
      document.getElementById('js-slide_prev').addEventListener('click', () => {
        target.prev()
      })
      document.getElementById('js-slide_next').addEventListener('click', () => {
        target.next()
      })
    }

    const chengeEvent = (e) => {
      const cnt = e.track.details.rel
      const targetList = document.querySelectorAll('.js-progress_list')
      const li = Array.prototype.slice.call(targetList, 0)
      li.forEach((element, index) => {
        if (index === cnt) {
          element.classList.add('is-act')
        } else {
          element.classList.remove('is-act')
        }
      })
    }
    const eventSlider = new KeenSlider(target, {
      slides: {
        perView: 1.3,
        spacing: 20,
        origin: 'center',
      },
      mode: 'free',
      spacing: 20,
      loop: true,
      duration: 2500,
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 2.4,
            spacing: 30,
          },
        },
        '(min-width: 1024px)': {
          slides: {
            perView: 4.4,
            spacing: 30,
          },
        },
        created: function (instance) {
          instance.refresh()
          init()
          clickEvent(instance)
        },
      },
      slideChanged: (e) => {
        chengeEvent(e)
      },
      created: (eventSlider) => {
        init()
        clickEvent(eventSlider)
      },
    })
  }
}
